import SIPAudioComponent from './webRtcAudio.vue'
import SIPAudioPrivateComponent from './privateWebRtcAudio.vue'

const SIPAudio = {
  install: function (Vue) {
    Vue.component("SIPAudio", SIPAudioComponent);
    Vue.component("SIPAudioPrivate", SIPAudioPrivateComponent);
  }
}
export default SIPAudio



// WEBPACK FOOTER //
// ./src/components/audio/SIPAudio.js